import React, { Fragment } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import DialogTitle from "@material-ui/core/DialogTitle";
import {IconButton} from "@material-ui/core";
import {Select, MenuItem,} from '@material-ui/core';
import _ from "lodash";
import moment from "moment";
import {
  Edit as EditIcon, 
  Delete as TrashcanIcon,
  Repeat,
} from "@material-ui/icons";
import alertConfig from "constants/alertConfig";
import ContactsSelection from "./ContactsSelection";
import { PrimaryButton, SecondaryButton } from "components/Global/Buttons";
import { PIPELINE } from "constants/status";
import { StyledDialogContent, StyledDropdown, LabelGrid, Label, HelperTextDiv, 
  StyledFormHelperText, AlertDropdownGrid, AdjustedDropdownGrid, AdjustedLabelGrid, 
  AdjustedLabel, StyledMaterialDatePicker, VerticalSpacer
} from "./Styles";
import { ToastSuccess } from "components/Global/Toasts/Toasty";
import { TwoDecimalPercentFormat, ThreeDecimalPercentFormat, FiveDecimalPercentFormat,
   FiveDecimalFloatFormat, ThreeDecimalFloatFormat, TwoDecimalFloatFormat, FloatFormat, DollarFormat , BooleanFormat} from "./FormattedInputs";

import { getNotificationById, addUpdateNotification, getAncillary,resetSelectedNotification, getNotificationsByDeal } from "store/state/notifications";
import { Transition, styles, dateMask, autoCorrectedDatePipe, emptyNotification} from "./AddEditAlertUtil";
import styled from 'styled-components';
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from '@material-ui/core/Tooltip';
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog"
import numberFormatter from "utils/numberFormatter";
import { blue } from "@material-ui/core/colors";
import {RadioInput} from 'components/Global/FastFormikMaterial';
import AddButton from 'components/Global/Buttons/AddButton';
import DeleteButton from 'components/Global/Buttons/DeleteButton';
import { floatingIndexList } from "constants/floatingIndexes";
import { trackReminderSave } from "lib/mixpanel";


const dealAlertLevel = "678ae77b-9693-11e9-8b5f-00ff12c3b408";


const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const Sidebar = styled.div`
  display:inline-block;
  width: 500px;
  height: 500px;
  min-height: 100%;
  vertical-align: top;
  padding-left: 20px;
  padding-right: 10px;
  //border-left : 1px solid #aaaaaa;
  overflow-y: auto;
`
const SidebarHeader = styled.p`
  color: #999999;
  font-size: 15pt;
`

const SidebarItem = styled.div`
  width:100%;
  font-weight: normal;
  border-bottom: 1px solid #aaaaaa;
  white-space: nowrap;
  overflow: hidden;
`
const SidebarText = styled.p`
  width:80%;
  display: inline-block;
  overflow: hidden;
  margin:0
`

const ButtonPanel = styled.div`
color: #2196F3;
text-align: right;
`
const ErrorContainer = styled.div`
  && {
    background-color: #eeeeee;
    color: rgb(153,153,153);
    width: 100%;
    height: 30px;
    border-radius: 3px;
    padding-top: 15px;
    padding-bottom: 10px;
    margin-top: 10px;
    text-align: center;
    vertical-align: middle;
  }
`

const DialogSubtitle = styled.div`
  color: #999999;
  font-size: 15pt;
  padding-bottom: 15px;
`

const frequencyOptions = [
  {label: "One Time", value: "oneTime"},
  {label: "Monthly", value: "monthly"},
  {label: "Quarterly", value: "quarterly"},
  {label: "Semi Annually", value: "semiAnnually"},
  {label: "Annually", value: "annually"},
];
const ContactDirectionsContainer = styled.div`
  font-weight: bold;
  text-align: center;
`;


const DATE_ALERT_TEST_TYPE_ID = "d37d5fa6-9676-11e9-8b5f-00ff12c3b408";

class AddEditAlert extends React.Component {  
  
  state = {
      selectedAlertType: null,
      notification: emptyNotification,
      confirmDialogOpen: false,           
      errorMessage: null,
      hasAlertDate: true,
      alertTypeSelection: false, 
    }; 

    onDeleteCancel = () =>{
      this.setState({confirmDialogOpen:false});
    }

    refreshNotifications = () => {
      if(this.props.dealId){
        const payload = {dealId:this.props.dealId, isAlert: this.props.isAlert};
        this.props.getNotificationsByDeal(payload);
      }
    }
    onDeleteConfirm = () => {
        this.props.addUpdateNotification({notification:{...this.state.notification,isActive:false}, shouldUpdateDealList:this.props.dealId, callback: this.refreshNotifications});
        this.setState({confirmDialogOpen:false});
    }

    addHasAlertDate = () => {
      this.setState({hasAlertDate:false});
    }

    removeHasAlertDate = () => {
      this.setState({hasAlertDate:true});
    }

    changeAlertTypeToCurrent = () =>
    {
      this.changeProjectedPeriod(null);
      this.removeHasAlertDate();
      this.setState({alertTypeSelection:false});
    }

    changeAlertTypeToProjected = () =>
    {
      //Have to make sure alertDate and alert definitions are reset before we execute rest of code
      this.removeAllAlertDefinitionValues().then(()=>{
      this.removeHasAlertDate();
      this.changeProjectedPeriod(1);
      this.setState({alertTypeSelection:true});
      });
    }


  getFormattedNotificationTriggerValue = (alert) => {
      switch(alert.alertType.alertFormatType.value){
        case  "PERCENT":
          return `${alert.testValue}%`
        case "CURRENCY":
          return `${numberFormatter.formatMoney(alert.testValue)}`
        case "NUMBER":
          return `${numberFormatter.formatDecimal(alert.testValue)}`
        case "BOOLEAN":
          return alert.testValue && alert.testValue === "1" ? "Qualified" : "Not Qualified";
        default:
          return alert.testValue;
      }
  }
  
  



 //filter out all notifications that are part of a series, then add back in only one record from each series based on earliest triggerValue
  condenseNotificationSeries = (notifications) => {
    notifications = _.cloneDeep(notifications);
    let seriesMap = {};
    notifications.forEach(x=> {
      if(!x.isAlert){
        if(x.frequency === "oneTime" && x.alertDefinitionValues.length === 1 && x.alertDefinitionValues[0].hasTriggered){
          x.shouldRemove = true;
        }
      }
      else if(x.seriesId) {
        x.triggerValueFormatted = new Date(x.triggerValue);
        if(!seriesMap[x.seriesId]) {
          seriesMap[x.seriesId] = [];
        }
        seriesMap[x.seriesId].push(x);
      }
    })
    let seriesIds = Object.keys(seriesMap);
    seriesIds.forEach(key => {
      seriesMap[key] = _.orderBy(seriesMap[key], "triggerValueFormatted", "ASC");
      notifications = notifications.filter(x=>x.seriesId!=key);
      notifications.push(seriesMap[key][0]);
    })
    return notifications.filter(x=>!x.shouldRemove);
  }

  renderExistingNotifications(){    
    if(this.props.isAlert && !this.props.alertsByDeal) return;

    if(!this.props.isAlert && !this.props.notificationsByDeal) return;

    const dealNotifications = this.props.isAlert ? this.props.alertsByDeal : this.props.notificationsByDeal;
    
    if(!dealNotifications)return;
    const { classes } = this.props;
    let output = [];
    dealNotifications.forEach(item=>{
      if(!item.isAlert){
        item.date = new Date(item.triggerValue); //create a date object for all reminders so that we can sort by it later
      }
    });
    if(dealNotifications){
      let sortedNotifications = _.sortBy(this.condenseNotificationSeries(dealNotifications),["date","updatedAt","triggerValue"]);
      if(this.props.isAlert) _.reverse(sortedNotifications);
      sortedNotifications.forEach(notification=>{
        if(notification.isAlert !== this.props.isAlert) {return;}
        if(notification.isAlert){
          if(notification.alertDefinitionValues.length >0)
          {
            output.push(
              <Fragment>
              <SidebarItem>
                <SidebarText style={{color:notification.id===this.state.notification.id?"#2196F3":"black"}}>
                  <ul>
                    {notification.alertDefinitionValues.map(currentValue =>
                      {
                        const alertTestType = this.isBooleanValue(currentValue) ? " = " : currentValue.alertTestType.value;
                        if(currentValue.alertTestType.value != "DATE") 
                          return (<li key={currentValue.id}>{`${currentValue.alertType.alertName} ${alertTestType} ${this.getFormattedNotificationTriggerValue(currentValue)}`}</li>);
                    },
                    )}
                  </ul>                
                </SidebarText>
                <ButtonPanel>
                  <Grid container alignItems="baseline" justify="flex-end">
                  {notification.alertDefinitionValues.map(currentValue =>
                      {
                        if(currentValue.alertTestType.value == "DATE") return (
                          <Label xs={8} style={{paddingRight: "15px"}}>{` On ${currentValue.testValue}`}</Label>

                        )
                    },
                    )}
                    {notification.maxYears >= 1 ?
                        <Label xs={8} style={{paddingRight: "15px"}}>{` Over the next ${notification.maxYears * 12} months `}</Label>
                      :
                      null

                    }
                    <EditIcon xs={2} style={{cursor:"pointer"}} onClick={()=>this.setState({notification})}/>
                    <TrashcanIcon xs={2} style={{cursor:"pointer"}} onClick={()=>{
                    this.setState({notification,confirmDialogOpen:true});
                    }}/>
                    </Grid>
                </ButtonPanel>
              </SidebarItem>
              </Fragment>
            );
          }
        
      }else{
        output.push(
          <Fragment> 
          <SidebarItem>
            <Tooltip classes={{tooltip:classes.lightTooltip}}  title={notification.message} placement="top-start">
                <SidebarText style={{color:notification.id===this.state.notification.id?"#2196F3":"black"}}>
                {this.isNotificationRecurring(notification) && <Repeat style={{marginRight:"10px", color: "#2196F3", verticalAlign: "bottom"}} />} {`${moment((this.getLatestTestValueForNotification(notification.alertDefinitionValues))).format('MM/DD/YYYY')} - ${notification.message.substring(0,22)}${notification.message.length>22?"...":""}`}
                </SidebarText>
            </Tooltip>
            <ButtonPanel>
            <EditIcon xs={2} style={{cursor:"pointer"}} onClick={()=>this.setState({notification:{ ...notification, startDate: this.getLatestTestValueForNotification(notification.alertDefinitionValues)}})}/>
              <TrashcanIcon style={{cursor:"pointer"}} onClick={()=>{
                this.setState({notification:{ ...notification, startDate: this.getLatestTestValueForNotification(notification.alertDefinitionValues)},confirmDialogOpen:true});
                }}/>
            </ButtonPanel>
          </SidebarItem>
          </Fragment>);
      }
      })
    }
    if(output.length===0){
    return <ErrorContainer>{`No ${this.props.isAlert?"Alerts":"Reminders"}`}</ErrorContainer>
    }
    return output;
  }
  
  componentDidMount(){
    const { notificationId } = this.props;
    if(!this.props.ancillary || this.props.ancillary.length === 0)
      this.props.getAncillary();

    if(notificationId !== null && notificationId !== 0){
      this.props.getNotificationById({id:notificationId});
    }

    if(this.props.dealId){
      this.props.getNotificationsByDeal({dealId:this.props.dealId, isAlert: this.props.isAlert});
    }
  }
  
  componentDidUpdate(prevProps, prevState) {
    const { notification, dealId, notificationId } = this.props;
    const {notificationId: prevNotificationId} = prevProps;      
    
    if(notificationId && notificationId !== prevNotificationId){
      this.props.getNotificationById({id:notificationId});
    }
    if(notification && notification !== prevProps.notification) {
      this.setState((state, props) => ({
        ...state, notification:{ ...notification }
      }));  
    }

    // set the dealId from props
    if (dealId != null && this.state.notification && this.state.notification.dealId !== dealId){      
      this.setState((state, props) => ({
        ...state, 
        notification:{ 
          ...this.state.notification, 
          dealId: dealId,
          alertLevelId: dealAlertLevel,          
         }
      }));
    }    
    // make sure the trigger value is set to today when notification is a reminder
    if (this.props.isAlert != null && this.state.notification && !this.props.isAlert && 
       (this.state.notification.startDate === undefined || this.state.notification.startDate === null)){         

        if(!this.props.isAlert && _.get(this.props.notification, 'startDate')){          
          this.setState({
            notification: {
            ...this.props.notification
            }
          })
         } else if(this.props.isOpen){                      
          this.setState((state, props) => ({            
            notification:{ 
              ...this.state.notification,
              ...this.props.notification, 
              startDate: !this.props.isAlert ? moment(new Date()).format('MM/DD/YYYY') : null,
             }
          }));
         }      
    }

   
  };


  triggerTypeFormat = (i) => {
    const { ancillary } = this.props;
    const { notification } = this.state;
    
      if (notification.alertDefinitionValues[i].alertTypeId && ancillary.alertTypes) {
        const selectedAlertType = _.chain(ancillary.alertTypes)
          .filter(x => x.value === notification.alertDefinitionValues[i].alertTypeId)
          .first()
          .value();

        if (selectedAlertType && selectedAlertType.alertFormatTypeId) {
          switch (selectedAlertType.alertFormatTypeId) {
            case alertConfig.PERCENT:
              switch (selectedAlertType.accuracy) {
                case 0.00001:
                  return FiveDecimalPercentFormat;
                case 0.001:
                  return ThreeDecimalPercentFormat;
                case 0.01:
                  return TwoDecimalPercentFormat;
              }
            case alertConfig.CURRENCY:
              return DollarFormat;
            case alertConfig.NUMBER:
              switch (selectedAlertType.accuracy) {
                case 0.00001:
                  return FiveDecimalFloatFormat;
                case 0.001:
                  return ThreeDecimalFloatFormat;
                case 0.01:
                  return TwoDecimalFloatFormat;
                case 1:
                  return FloatFormat;
              }
            case alertConfig.BOOLEAN:
              return BooleanFormat;
            default:
              return FloatFormat;
          }
        }
      }
  };

  setAlertTypeValue = selectedOption => {    
    this.setState({
      selectedAlertType: selectedOption
    });
    return this.handleChange("alertTypeId", selectedOption);
  };

  getFilteredAlertTypes = () => {
    const { ancillary } = this.props;
    const { notification } = this.state;
    
    const isProjected = notification.maxYears !== undefined && notification.maxYears !== null;
    const portfolioTypes = ancillary.alertTypes ? ancillary.alertTypes.filter(x => x.alertLevelId === alertConfig.ALERT_FOR_PORTFOLIO) : [];
    const fundTypes = ancillary.alertTypes ? ancillary.alertTypes.filter(x => x.alertLevelId === alertConfig.ALERT_FOR_FUND) : [];
    const dealTypes = ancillary.alertTypes ? ancillary.alertTypes.filter(x => x.alertLevelId === alertConfig.ALERT_FOR_DEAL) : [];
    
    switch (notification.alertLevelId) {
      case alertConfig.ALERT_FOR_PORTFOLIO:        
        let allPortfolioTypes = _.concat(portfolioTypes);
        if(isProjected)
        allPortfolioTypes = _.intersectionWith(allPortfolioTypes, alertConfig.PROJECTED_ALERT_TYPES_LIST, this.customComparator);
        return allPortfolioTypes

      case alertConfig.ALERT_FOR_FUND:
        let allFundTypes = _.concat(portfolioTypes, fundTypes);
        if(isProjected)
          allFundTypes = _.intersectionWith(allFundTypes, alertConfig.PROJECTED_ALERT_TYPES_LIST, this.customComparator);
        return allFundTypes

      case alertConfig.ALERT_FOR_DEAL:
        let allDealTypes = _.concat(portfolioTypes, fundTypes, dealTypes);
        const selectedDeal = _.chain(ancillary.companyDeals).filter(x => x.value === notification.dealId).first().value();

        if(isProjected)
          allDealTypes = _.intersectionWith(allDealTypes, alertConfig.PROJECTED_ALERT_TYPES_LIST, this.customComparator);
        
        if ((selectedDeal && selectedDeal.dealStatusId === PIPELINE) || this.props.isPipelineDeal)
          return allDealTypes.filter(x => !x.excludePipeline);
        return allDealTypes;

      case alertConfig.ALERT_FOR_GUARANTOR:
        return [];
      default:
        return ancillary.alertTypes;
    }
  };

  customComparator = (a, b) => {
    return a.id === b.value;
  }  
    
  cancelNotification = () =>{        
    emptyNotification.alertContacts=[]; 
    emptyNotification.alertDefinitionValues = [{id: null,
      alertDefinitionId: null,
      alertTypeId: null,
      alertTestTypeId: null,
      testValue: null,}];
    this.setState({      
      notification:emptyNotification,
      errorMessage: null,
      hasAlertDate: true,
    });
    this.props.resetSelectedNotification();
    if(!this.props.dealId || !this.state.notification.id)this.props.handleCancel();
  }

  isValidNotification = (notification) => {
    let isValid = true;
    //isAlert - fail: set from props
    if(notification.isAlert === undefined || notification.isAlert === null){
      this.setState({
        notification: {
          ...notification,
          isAlert: this.props.isAlert,
          isActive: true
        }
      },this.saveNotification);
      isValid = false;
    }

    if(notification.isAlert){
      isValid = this.areRequiredAlertFieldsSet(notification);
      if(!isValid)
        this.setState({errorMessage: 'All fields are required. Please complete form in order to save alert or reminder.'})
    }
    if(notification.isAlert === false){
      isValid = this.areRequiredReminderFieldsSet(notification);
      if(!isValid)
        this.setState({errorMessage: 'All fields are required. Please complete form in order to save alert or reminder.'})
    }
    if(notification.message && notification.message.length>255){
      isValid=false;
      this.setState({errorMessage: `Message too long (${notification.message.length}/255)`});
    }
    
    // Contacts check = fail: contacts not selected    
    if(!notification.alertContacts || notification.alertContacts.length === 0){
      this.setState({errorMessage: `You must select at least one contact to save this ${this.props.isAlert ? "alert" : "reminder"}.`});
      isValid =  false;
    }
    return isValid;
  }

  areRequiredAlertFieldsSet = (alert) => {   
    var validation = true; 
    alert.alertDefinitionValues.map(currentValue =>
      {
        if(!currentValue.alertTypeId && !currentValue.alertTestTypeId == DATE_ALERT_TEST_TYPE_ID)
          validation = false;
        if(this.isBooleanValue(currentValue))
          currentValue.alertTestTypeId = "d37d5f89-9676-11e9-8b5f-00ff12c3b408";
        if(!currentValue.alertTestTypeId)
          validation = false;
        if(!currentValue.testValue)
          validation = false;
      });
    if(!validation)
      return false;
    if(!alert.alertLevelId)
      return false;
    if(alert.alertLevelId === alertConfig.ALERT_FOR_PORTFOLIO && (alert.dealId || alert.fundId))
      return false;
    if(alert.alertLevelId === alertConfig.ALERT_FOR_DEAL && !alert.dealId)
      return false;
    if(alert.alertLevelId === alertConfig.ALERT_FOR_FUND && !alert.fundId)
      return false;
    if(!alert.message)
      return false;
    return true;

  }

  areRequiredReminderFieldsSet = (reminder) => {  
    if(!reminder.alertLevelId)
      return false;
    if(reminder.alertLevelId === alertConfig.ALERT_FOR_PORTFOLIO && (reminder.dealId || reminder.fundId))
      return false;
    if(reminder.alertLevelId === alertConfig.ALERT_FOR_DEAL && !reminder.dealId)
      return false;
    if(reminder.alertLevelId === alertConfig.ALERT_FOR_FUND && !reminder.fundId)
      return false;
    if(!reminder.startDate)
      return false;
    if(!reminder.message)
      return false;
    return true;

  }

  saveNotification = () =>{    
    const {isAlert} = this.props;
    const {notification} = this.state;
    
    let alertDefinitionValues = [{id: null,
      alertDefinitionId: null,
      alertTypeId: null,
      alertTestTypeId: null,
      testValue: null,}];
    if(this.isValidNotification(notification)) {
        this.props.addUpdateNotification({notification, shouldUpdateDealList:this.props.dealId, callback: this.refreshNotifications});
        let isNew = !!this.state.notification.id;
        this.setState({
          ...this.state,
          notification:{
            alertDefinitionValues
          },
          errorMessage: null
        });
        if(!this.props.dealId) this.props.handleSave()
        ToastSuccess(`${isAlert ? "Alert" : "Reminder"} Saved`);
        if (!isAlert) {
          trackReminderSave();
        }
    }
  }
  
  handleTextChange = ({ target: { name, value } }) => {
      const { notification } = this.state;
      if(notification[name] !== value){
        this.setState({
          notification: {
            ...notification,
            [name]: value
          }
        });
      }
    };
  
    handleChange = ( name, selectedOption  ) => {
      const { notification } = this.state;
        this.setState({
          notification: { 
              ...notification, 
              [name]: selectedOption ? selectedOption.value : null
            }
        });        
    };

    handleReminderFrequencyChange = ( name, selectedOption  ) => {
      const { notification } = this.state;
      if(selectedOption.value === "oneTime")
      {
        notification.endDate = null;
      }
        this.setState({
          notification: { 
              ...notification, 
              [name]: selectedOption ? selectedOption.value : null
            }
        });        
    };

  
    checkIds = () => {      
      const { ancillary } = this.props;
      const { notification } = this.state;

      let allClear = true;
      if(notification.alertContacts && notification.alertContacts.length > 0){
          notification.alertContacts.forEach(alertContact => {
              if(allClear){
                  allClear = _.some(ancillary.companyContacts, ['id', alertContact.contactId]);
              }
          });
      }
      return allClear;
    };
  
    isChecked = (contact) => {      
      const { notification } = this.state;
      if(!notification.alertContacts)
        return false;
      return _.findIndex(notification.alertContacts, (o) => o.contactId == contact.id ) > -1;    
    };
  
    handleAlertContactsChange = contact => event => {
      const { ancillary } = this.props;
      const { notification } = this.state;

      const newAlertContact = {contactId: contact.id, contact: contact}
      let updatedArray = [];
      if(event.target.checked){
          updatedArray = notification.alertContacts || [];
          updatedArray.push(newAlertContact);
      } else {
          updatedArray = _.reject(notification.alertContacts, (o) => {
              return o.contactId === newAlertContact.contactId;
              });
      }
      this.setState({
          notification:{ ...notification, alertContacts: updatedArray }
      });
    };

    addAlertDefinition = () => {
      const { notification } = this.state;
      const emptyDefinitionValues = { id: null,
        alertDefinitionId: null,
        alertTypeId: null,
        alertTestTypeId: null,
        testValue: null,};

      const alertDefinitions = notification.alertDefinitionValues;

      if(alertDefinitions && alertDefinitions.length > 0){
        let dateValueIndex =_.findIndex(alertDefinitions, { 'alertTestTypeId': 'd37d5fa6-9676-11e9-8b5f-00ff12c3b408'});
        if(dateValueIndex > -1) {
          alertDefinitions.splice(dateValueIndex-1,0,emptyDefinitionValues)
        } else {
          alertDefinitions.push(emptyDefinitionValues);
        }
      } else {
        alertDefinitions.push(emptyDefinitionValues);
      }
      
      this.setState({
        notification:{ ...notification, alertDefinitionValues: alertDefinitions }
      });
    };

    removeAlertDefinition = index => {
      const { notification } = this.state;
      const alertDefinitions = [...notification.alertDefinitionValues.slice(0, index), ...notification.alertDefinitionValues.slice(index + 1)];
      this.setState({
        notification:{ ...notification, alertDefinitionValues: alertDefinitions }});
    };

    addDateAlertDefinition = () => {
      const { notification } = this.state;
      const emptyDefinitionValues = { id: null,
        alertDefinitionId: null,
        alertTypeId: null,
        alertTestTypeId:DATE_ALERT_TEST_TYPE_ID,
        testValue: null,};
      const alertDefinitions = [...notification.alertDefinitionValues, emptyDefinitionValues];
      this.setState({
        notification:{ ...notification, alertDefinitionValues: alertDefinitions }
      });
    };


    handleAlertDefinitionChange = (index ,name, selectedOption  ) => {
      const { notification } = this.state;
      const updatedAlertDefinitions = [...notification.alertDefinitionValues];
      if(updatedAlertDefinitions[index][name] !== selectedOption){
        updatedAlertDefinitions[index][name] = selectedOption ? selectedOption.value : null;
        this.setState({
          notification: { 
              ...notification, 
              alertDefinitionValues : updatedAlertDefinitions
            }
        });  
      }   
    };

    handleAlertDefinitionTextChange = (name,value,index) => {
      const { notification } = this.state;
      const updatedAlertDefinitions = [...notification.alertDefinitionValues];
      if(updatedAlertDefinitions[index][name] !== value){
        updatedAlertDefinitions[index][name] = value;
        this.setState({
          notification: { 
              ...notification, 
              alertDefinitionValues : updatedAlertDefinitions
            }
        });  
      }
    };

    setAlertDefinitionTypeValue = (selectedOption,index,name) => {    
      
      let shouldSetTriggerValue = false;
      if(name === "alertTypeId" && selectedOption.value === alertConfig.EXTENSION_QUALIFICATION)
        shouldSetTriggerValue = true;
      const { notification } = this.state;
      const updatedAlertDefinitions = [...notification.alertDefinitionValues];
      if(updatedAlertDefinitions[index][name] !== selectedOption){
        updatedAlertDefinitions[index][name] = selectedOption ? selectedOption.value : null;
        updatedAlertDefinitions[index].testValue = shouldSetTriggerValue ? "1" : null;
        
        this.setState({
          notification: { 
              ...notification, 
              alertDefinitionValues : updatedAlertDefinitions
            }
        });  
      }
    };

    changeProjectedPeriod = (value) => {
      const {notification} = this.state;
      this.setState({
        notification: { 
            ...notification, 
            maxYears : value
          }
      });  
    }



    reOrganizeAlertDefinitionValuesForDate = () => {
      const { notification} = this.state;
      if(notification.alertDefinitionValues && notification.alertDefinitionValues.length > 0 )
      {
        const defValues =  [...notification.alertDefinitionValues];
        const clone = defValues;
        let changed = false;
        for(let i = 0; i < defValues.length; i++){
          if(defValues[0].alertTestTypeId === DATE_ALERT_TEST_TYPE_ID)
          {
            const flipper = defValues[i];
            const endArray = defValues[(defValues.length -1)];
            clone[i] = endArray;
            clone[(defValues.length -1)] = flipper;
            changed = true;
            break;
          }
        }
        if(changed)
        {
          this.setState({
            notification: { 
                ...notification, 
                alertDefinitionValues : clone
              }
          }); 
        }
      }
      
    }

    removeAllAlertDefinitionValues = async() =>{
      const {notification} = this.state;
      if(notification.alertDefinitionValues && notification.alertDefinitionValues.length > 0 )
      {
        let alertDefinitionValue = [{id: null,
          alertDefinitionId: null,
          alertTypeId: null,
          alertTestTypeId: null,
          testValue: null,}];
        this.setState({
          notification:{ ...notification, alertDefinitionValues: alertDefinitionValue }
        });
      }
    }
  
  render() {    
    const {isOpen,ancillary,classes,isAlert, dealId} = this.props;
    const { notification } = this.state;
    if(!notification.alertDefinitionValues || notification.alertDefinitionValues.length < 1)
    {
      let alertDefinitionValue = [{id: null,
        alertDefinitionId: null,
        alertTypeId: null,
        alertTestTypeId: null,
        testValue: null,}];
      this.setState({
        notification:{ ...notification, alertDefinitionValues: alertDefinitionValue }
      });
    }

  


    if (!ancillary || !notification) return null;

    const showAlertFor = notification.alertLevelId && notification.alertLevelId !== alertConfig.ALERT_FOR_PORTFOLIO && notification.alertLevelId !== alertConfig.ALERT_FOR_GUARANTOR;
    const isFund = notification.alertLevelId && notification.alertLevelId === alertConfig.ALERT_FOR_FUND; 
    const fieldName = isFund ? "fundId" : "dealId";
    const options = isFund ? ancillary.companyFunds : ancillary.companyDeals;

    
    this.reOrganizeAlertDefinitionValuesForDate();


    
    if (!isOpen) return null;
    
    return (
      <div>
        <Dialog
          id="alertModel"
          maxWidth={false}
          open={isOpen}
          onClose={this.cancelNotification} 
          scroll={"paper"}
          TransitionComponent={Transition}
          aria-labelledby="form-dialog-title"
          style={{overflowX:"scroll" }}
        >
          <DialogTitle id="form-dialog-title">
            {isAlert ? (dealId?"Alerts":"Alert") : (dealId?"Reminders":"Reminder")}
          </DialogTitle>
          <div style={{minWidth: dealId ? 1280 : "100%" }}>
          <div  style={{display:"inline-block", height:"100%", borderRight : dealId?"1px solid #aaaaaa":"0px solid black"}}> 
          
          <StyledDialogContent>
            {dealId &&
            <DialogSubtitle>
            {`Add ${isAlert?"Alert":"Reminder"}`}
          </DialogSubtitle>}
            {isAlert ? 
              this.renderAlert(showAlertFor, options, fieldName) :
              this.renderReminder(showAlertFor, options, fieldName)
            }
            {dealId && 
            <StyledDialogIconButton onClick={()=>{
              this.setState({      
                notification:emptyNotification,
                errorMessage: null,
              });
              this.props.resetSelectedNotification();
              this.props.handleCancel();
              }}>
              <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
            </StyledDialogIconButton>
            }
            {isAlert ? 
            <AddButton
              title="Add a test"
              onClick={() => {
                this.addAlertDefinition();               
              }}
            /> : null}
            
            {isAlert && this.state.hasAlertDate && !notification.maxYears >= 1 ?
              <AddButton
                title="Add a testing date"
                onClick={() => {
                  this.addHasAlertDate();     
                  this.addDateAlertDefinition();        
                }}
              />
              :
              null
            }
            {notification.maxYears >= 1 ?
              (this.state.alertTypeSelection = true, this.state.hasAlertDate = true) : this.state.alertTypeSelection = false
            }

            {this.state.alertTypeSelection ?
              <Grid item>
                <Label>Over the next 
                <input type="radio" value={1} checked={notification.maxYears == 1 || notification.maxYears == null} onChange={({target}) => this.changeProjectedPeriod(target.value)}/>12 Months
                <input type="radio" value={2} checked={notification.maxYears == 2} onChange={({target}) => this.changeProjectedPeriod(target.value)}/>24 Months
                <input type="radio" value={3} checked={notification.maxYears == 3} onChange={({target}) => this.changeProjectedPeriod(target.value)}/>36 Months 
                </Label>
              </Grid>
              :
              null
          }

            {this.state.hasAlertDate ? 
            <Grid container alignItems="baseline" justify="space-between">
              <Grid item xs={2}>
                <Label>Send message</Label>
              </Grid>
              <Grid item xs={10}>
                <TextField     
                  InputLabelProps={{
                    classes: {
                      root: classes.textFieldLabel,                      
                    }
                  }}                                
                  InputProps={{ 
                    classes: { 
                      input: classes.inputField, 
                      underline: classes.underline,
                      error: classes.error 
                    }, 
                     }} 
                  placeholder="Message"
                  label="Message*"                  
                  multiline 
                  value={this.state.notification.message || ''} 
                  onChange={this.handleTextChange} 
                  name="message" 
                  inputProps={{ maxLength: 300 }} 
                  fullWidth /> 
              </Grid>                              
            </Grid>
              :
            null
            
            }
            
            <VerticalSpacer/>            
            <ContactsSelection checkIds={this.checkIds} 
              isChecked={this.isChecked}
              handleAlertContactsChange={this.handleAlertContactsChange} 
              companyContacts={ancillary.companyContacts} 
              notificationId={notification.id}
              isAlert={this.props.isAlert} />                  
          </StyledDialogContent>
          <Grid container>
            <Grid item xs={12}>
            <ContactDirectionsContainer>*You must select your name to receive this {this.props.isAlert ? "alert" : "reminder"}.</ContactDirectionsContainer>
            </Grid>
            <Grid item xs={6}>
              {this.state.errorMessage && (
                <HelperTextDiv>
                  <StyledFormHelperText>{this.state.errorMessage}</StyledFormHelperText>
                </HelperTextDiv>)}
            </Grid>
            
            <Grid item xs={6}>
              <DialogActions>
                <SecondaryButton id="cancelbutton" onClick={this.cancelNotification}>Cancel</SecondaryButton>
                <PrimaryButton id="saveButton" onClick={this.saveNotification}>Save</PrimaryButton>
              </DialogActions>
            </Grid>
          </Grid>
          </div>
          {dealId &&
          <Sidebar id="sidebar">
            <SidebarHeader>{isAlert?"Existing Alerts":"Existing Reminders"}</SidebarHeader>
            {this.renderExistingNotifications()}
          </Sidebar>
          }
          </div>
        </Dialog>
        <SimpleConfirmDialog
          title="Confirm Delete"
          message={`Are you sure you want to delete this ${this.props.isAlert?"alert":"reminder"}?`}
          modalOpen={this.state.confirmDialogOpen}
          handleNo={this.onDeleteCancel}
          handleYes={this.onDeleteConfirm}
          noText="Cancel"
          yesText="Confirm"
        />
      </div>
    );
  }

  renderDateAlert = (index) => {
    const { ancillary, classes, dealId } = this.props;    
    const { notification } = this.state;
    if(this.state.hasAlertDate){
      this.addHasAlertDate();
    }


    return (
      <Grid item container alignItems='center' justify='space-between' spacing={8}>
      <Grid item xs={2}>
        <Label>On</Label>
      </Grid>
      <Grid item xs={4}>
      <StyledMaterialDatePicker label="On" 
      name="testValue" 
      keyboard={true}
      InputProps={{
        disableUnderline:true,
      }}                        
      mask={dateMask}
      invalidDateMessage={null}
      maxDateMessage={null}
      minDateMessage={null}
      invalidLabel=''            
      pipe={autoCorrectedDatePipe}            
      disableOpenOnEnter
      format="MM/DD/YYYY" 
      value={notification.alertDefinitionValues[index].testValue || '' }  
      onChange={selectedOption => { 
        selectedOption.value = moment(selectedOption).format( "MM/DD/YYYY" ); 
        return this.handleAlertDefinitionTextChange("testValue", selectedOption.value,index); }

    } />
     </Grid>
    <Grid item xs={1}>
     <TrashcanIcon style={{cursor:"pointer", color: "#2196F3", paddingLeft: "40px", paddingTop: "20px"}}
        title="Delete"
        onClick={() => {
          this.removeHasAlertDate();      
          this.removeAlertDefinition(index)         
        }}/>
        </Grid>
      
      <Grid item xs={5}>
      </Grid>
      <Grid item xs={2}>
        <Label>Pass message</Label>
      </Grid>
      <Grid item xs={10}>
        <TextField     
          InputLabelProps={{
            classes: {
              root: classes.textFieldLabel,                      
            }
          }}                                
          InputProps={{ 
            classes: { 
              input: classes.inputField, 
              underline: classes.underline,
              error: classes.error 
            }, 
            }} 
          placeholder="Pass Message"
          label="Pass Message*"                  
          multiline 
          value={this.state.notification.message || ''} 
          onChange={this.handleTextChange} 
          name="message" 
          inputProps={{ maxLength: 300 }} 
          fullWidth /> 
      </Grid>              
      <Grid item xs={2}>
        <Label>Fail message</Label>
      </Grid>
      <Grid item xs={10}>
        <TextField     
          InputLabelProps={{
            classes: {
              root: classes.textFieldLabel,                      
            }
          }}                                
          InputProps={{ 
            classes: { 
              input: classes.inputField, 
              underline: classes.underline,
              error: classes.error 
            }, 
            }} 
          placeholder="Fail Message"
          label="Fail Message*"                  
          multiline 
          value={this.state.notification.failMessage || ''} 
          onChange={this.handleTextChange}
          name="failMessage" 
          inputProps={{ maxLength: 300 }} 
          fullWidth /> 
      </Grid>                              
    </Grid>
    )

  }
  isBooleanValue = (alertDefinitionValue) => {
    return alertDefinitionValue && alertDefinitionValue.alertTypeId === alertConfig.EXTENSION_QUALIFICATION;
  }
  
  renderAlert = (showAlertFor, options, fieldName) => {
    const { ancillary, classes, dealId } = this.props;    
    const { notification } = this.state;
    
    return  (      
      <Grid container direction="column">
        {!dealId && (<Fragment><AlertDropdownGrid item container alignItems='center' justify='flex-start' spacing={8}>
          
          <AdjustedDropdownGrid xs={5} item> 
            <StyledDropdown id="alertLevelId" 
              inputProps={{ name: "alertLevelId" }} 
              label="Alert Level*"
              options={ancillary.alertLevels} 
              selectedValue={notification.alertLevelId} 
              onChange={selectedOption => { 
              this.handleChange("fundIdId", null); 
              this.handleChange("dealId", null); 
              this.handleChange("alertLevelId", selectedOption); }} />     
          </AdjustedDropdownGrid>

          {showAlertFor && (
            <AdjustedDropdownGrid xs={7} item> 
              <StyledDropdown id="alertForValue" 
                options={options} label="Alert For*" 
                selectedValue={notification[fieldName]} 
                onChange={selectedOption => this.handleChange(fieldName, selectedOption) } 
                inputProps={{ name: "alertForValue" }} /> 
              </AdjustedDropdownGrid>      
          )}           
        </AlertDropdownGrid>                 
        <VerticalSpacer/></Fragment> )}  

        {notification.alertDefinitionValues && notification.alertDefinitionValues.length > 0 && 
        (
          <Grid item>
            <input type="radio"  value={0} checked={notification.maxYears == 0 || notification.maxYears == null } onChange={this.changeAlertTypeToCurrent}/>Current
            <input type="radio"  value={1} checked={notification.maxYears >=1} onChange={this.changeAlertTypeToProjected}/>Projected        
        
            <Grid item container alignItems='center' justify='space-between' spacing={8} id="statementBuildGrid" key={0} index={0} required>
              <AdjustedLabelGrid item xs={1}>
                <AdjustedLabel>If</AdjustedLabel>              
              </AdjustedLabelGrid>
              <AdjustedDropdownGrid item xs={4}> 
                <StyledDropdown id="AlertTypeValue" 
                options={this.getFilteredAlertTypes()} 
                label="Alert Type*" 
                margin="dense" 
                selectedValue={notification.alertDefinitionValues[0].alertTypeId} 
                onChange={selectedOption => this.setAlertDefinitionTypeValue(selectedOption,0,"alertTypeId") } 
                inputProps={{ name: "alertTypeId" }} />              
              </AdjustedDropdownGrid>            
              <AdjustedDropdownGrid item xs={4}>   
              { !this.isBooleanValue(notification.alertDefinitionValues[0]) && <StyledDropdown id="alertTestTypeValue" 
                  label="Test Types*" 
                  margin="dense" 
                  selectedValue={notification.alertDefinitionValues[0].alertTestTypeId} 
                  onChange={selectedOption => this.handleAlertDefinitionChange(0,"alertTestTypeId", selectedOption) } 
                  inputProps={{ name: "alertTestTypeId" }}
                  options={ancillary.alertTestTypes} />
              } 
              </AdjustedDropdownGrid>            
              <Grid item xs={2}>
                {this.state.notification.alertDefinitionValues[0].alertTypeId && <TextField label="Trigger Value*" name="testValue" 
                  value={notification.alertDefinitionValues[0].testValue || '' } 
                  onChange={({target}) => this.handleAlertDefinitionTextChange(target.name, target.value, 0)} 
                  fullWidth                
                  InputLabelProps={{
                    classes: { root: classes.textFieldLabel}
                  }}
                  InputProps={{ 
                  classes: { 
                    input: classes.inputField,
                    underline: classes.underline, 
                    error: classes.error
                  },                      
                  inputComponent: this.triggerTypeFormat(0), 
                  fix: "$", 
                scale: "6" }} />   
                }    
                </Grid> 
                <Grid item xs={1}><></></Grid>
            </Grid>
          </Grid>
        )}

        {notification.alertDefinitionValues &&
                notification.alertDefinitionValues.map((x, i) => {
                  if (i === 0) return null;
                  if(x.alertTestTypeId == DATE_ALERT_TEST_TYPE_ID) return this.renderDateAlert(i);
                  
                  return (
            <Grid item container alignItems='center' justify='space-between' spacing={8} id="statementBuildGrid" key={i} index={i}>
                        <AdjustedLabelGrid item xs={1}>
                          <AdjustedLabel>And</AdjustedLabel>              
                        </AdjustedLabelGrid>
                        <AdjustedDropdownGrid item xs={4}> 
                          <StyledDropdown id="AlertTypeValue" 
                          options={this.getFilteredAlertTypes()} 
                          label="Alert Type*" 
                          margin="dense" 
                          selectedValue={notification.alertDefinitionValues[i].alertTypeId} 
                          onChange={selectedOption => this.setAlertDefinitionTypeValue(selectedOption,i,"alertTypeId") } 
                          inputProps={{ name: "alertTypeId" }} />              
                        </AdjustedDropdownGrid>            
                        <AdjustedDropdownGrid item xs={4}>   
                          {!this.isBooleanValue(notification.alertDefinitionValues[i]) && <StyledDropdown id="alertTestTypeValue" 
                            label="Test Types*" 
                            margin="dense" 
                            selectedValue={notification.alertDefinitionValues[i].alertTestTypeId} 
                            onChange={selectedOption => this.handleAlertDefinitionChange(i,"alertTestTypeId", selectedOption) } 
                            inputProps={{ name: "alertTestTypeId" }}
                            options={ancillary.alertTestTypes} />  }            
                        </AdjustedDropdownGrid>            
                        <Grid item xs={2} alignItems="baseline" justify='flex-start'>
                          {this.state.notification.alertDefinitionValues[i].alertTypeId && <TextField label="Trigger Value*" name="testValue" 
                            value={notification.alertDefinitionValues[i].testValue || '' }
                            onChange={({target}) => this.handleAlertDefinitionTextChange(target.name, target.value, i)}
                            fullWidth                
                            InputLabelProps={{
                              classes: { root: classes.textFieldLabel}
                            }}
                            InputProps={{ 
                            classes: { 
                              input: classes.inputField,
                              underline: classes.underline, 
                              error: classes.error
                            },                      
                            inputComponent: this.triggerTypeFormat(i), 
                            fix: "$", 
                          scale: "6" }} />   }   
                        </Grid>
                        <Grid item xs={1}>
                        <TrashcanIcon style={{cursor:"pointer", color: "#2196F3", paddingTop : "20px"}} title="Remove Above Test" onClick={() => { this.removeAlertDefinition(i);}} />  
                        </Grid>
            </Grid>
          );
          })}                      
                      
          <VerticalSpacer/>
        </Grid>) 
  }


  isNotificationRecurring = (notification) => {
    return notification.frequency && notification.frequency != "oneTime";
  }

  getLatestTestValueForNotification = (alertDefinitionValues) => {

    if(!alertDefinitionValues || alertDefinitionValues.length === 0) 
      return "";

    if(alertDefinitionValues && alertDefinitionValues.length === 1)
      return alertDefinitionValues[0].testValue;

    const now = moment(new Date());
    let sortedFiltered = alertDefinitionValues.filter(x => now.isBefore(x.testValue)).sort((a, b) => moment(a.testValue) - moment(b.testValue));
    if(sortedFiltered && sortedFiltered.length > 0)
      return sortedFiltered[0].testValue;
    
    return "";    
  }

   renderReminder = (showAlertFor, options, fieldName) => {
    const { ancillary, classes, dealId } = this.props;
    const { notification } = this.state;

    if(!this.state.hasAlertDate){ //Make sure the send Message shows up for the user
      this.removeHasAlertDate();
    }
    
    if(notification == null || notification.alertDefinitionValues == null) return null;

    return (
      <Grid container direction="column">      
        <Grid container  item alignContent="center" >
          <StyledMaterialDatePicker label={this.isNotificationRecurring(notification) ? "*Begin Date" : "Date*"} 
            name="testValue" 
            keyboard={true}
            InputProps={{
              disableUnderline:true,
            }}                        
            mask={dateMask}
            invalidDateMessage={null}
            maxDateMessage={null}
            minDateMessage={null}
            invalidLabel=''            
            pipe={autoCorrectedDatePipe}            
            disableOpenOnEnter
            format="MM/DD/YYYY" 
            value={notification.startDate} 
            onChange={selectedOption => { 
              selectedOption.value = moment(selectedOption).format( "MM/DD/YYYY" ); 
              return this.handleChange("startDate",selectedOption); }
            } /> 
            { <div style={{display: "inline-block", verticalAlign: "bottom", paddingTop: "20px", marginLeft: "20px", marginRight: "20px"}}>
              <div style={{display: "inline-block"}}>
                Frequency: 
              </div>
              <Select
                style={{marginLeft: "10px"}}
                name={"frequency"}
                value={notification.frequency || "oneTime"}
                onChange={event => {
                this.handleReminderFrequencyChange("frequency", event.target)
                }}
                >
                    {frequencyOptions &&
                      frequencyOptions.map(item => (
                        <MenuItem key={item.label} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
              </Select>            
            </div> }

          {this.isNotificationRecurring(notification) && <StyledMaterialDatePicker label= {"End Date"} 
            name="endDate" 
            keyboard={true}
            InputProps={{
              disableUnderline:true,
            }}                        
            style={{marginTop: "10px"}}
            mask={dateMask}
            invalidDateMessage={null}
            maxDateMessage={null}
            minDateMessage={null}
            invalidLabel=''            
            pipe={autoCorrectedDatePipe}            
            disableOpenOnEnter
            format="MM/DD/YYYY" 
            value={notification.endDate} 
            onChange={selectedOption => { 
              selectedOption.value = moment(selectedOption).format( "MM/DD/YYYY" ); 
              return this.handleChange("endDate", selectedOption); }
            } /> }            
        </Grid>
        {!dealId && (<Fragment>
        <VerticalSpacer/>   
        <Grid item container alignItems='center' justify='flex-start' spacing={8}>
          <Grid item xs={5}>
            <StyledDropdown id="alertLevelId" 
              inputProps={{ name: "alertLevelId" }} 
              label="Reminder Level*" 
              options={ancillary.alertLevels} 
              selectedValue={notification.alertLevelId} 
              onChange={selectedOption => { 
                this.handleChange("fundIdId", null); 
                this.handleChange("dealId", null); 
                this.handleChange("alertLevelId", selectedOption); }}/>
          </Grid>      
          <Grid item xs={6}>
            {showAlertFor && (
            <StyledDropdown id="alertForValue" 
                options={options}
                label="Reminder For*" 
                margin="dense" 
                selectedValue={notification[fieldName]} 
                onChange={selectedOption => this.handleChange(fieldName, selectedOption) } 
                inputProps={{ name: "alertForValue" }} /> )} 
          </Grid>
        </Grid></Fragment>)}
        <VerticalSpacer/>  
      </Grid>)
  }

}


const mapStateToProps = ({ notifications }) => {  
  return ({
            notificationsByDeal: notifications.notificationsByDeal,
            alertsByDeal: notifications.alertsByDeal,
            notification: notifications.selectedNotification ? notifications.selectedNotification : {}, 
            ancillary: notifications.ancillary || []
          })
  };

export default compose(  
  withStyles(styles),
  connect(
    mapStateToProps,
    {    
        getNotificationById, 
        resetSelectedNotification,
        addUpdateNotification,
        getNotificationsByDeal,
        getAncillary
    }
))(AddEditAlert);